import {iconUrl} from 'data/icon'
import {ensureStatuses} from '../type'
import {SHARED} from './SHARED'

export const GNB = ensureStatuses({
	SONIC_BREAK: {
		id: 1837,
		name: 'Sonic Break',
		icon: iconUrl(213607),
		duration: 30000,
	},
	BRUTAL_SHELL: {
		id: 1898,
		name: 'Brutal Shell',
		icon: iconUrl(213614),
		duration: 30000,
	},
	BOW_SHOCK: {
		id: 1838,
		name: 'Bow Shock',
		icon: iconUrl(213608),
		duration: 15000,
	},
	NO_MERCY: {
		id: 1831,
		name: 'No Mercy',
		icon: iconUrl(213601),
		duration: 20000,
	},
	READY_TO_RIP: {
		id: 1842,
		name: 'Ready to Rip',
		icon: iconUrl(213611),
		duration: 10000,
	},
	READY_TO_TEAR: {
		id: 1843,
		name: 'Ready to Tear',
		icon: iconUrl(213612),
		duration: 10000,
	},
	READY_TO_GOUGE: {
		id: 1844,
		name: 'Ready to Gouge',
		icon: iconUrl(213613),
		duration: 10000,
	},
	READY_TO_BLAST: {
		id: 2686,
		name: 'Ready to Blast',
		icon: iconUrl(213618),
		duration: 10000,
	},
	READY_TO_RAZE: {
		id: 3839,
		name: 'Ready to Raze',
		icon: iconUrl(213620),
		duration: 10000,
	},
	READY_TO_BREAK: {
		id: 3886,
		name: 'Ready to Break',
		icon: iconUrl(213622),
		duration: 30000,
	},
	READY_TO_REIGN: {
		id: 3840,
		name: 'Ready to Reign',
		icon: iconUrl(213621),
		duration: 30000,
	},
	AURORA: {
		id: 1835,
		name: 'Aurora',
		icon: iconUrl(213605),
		duration: 18000,
	},
	HEART_OF_STONE: {
		id: 1840,
		name: 'Heart of Stone',
		icon: iconUrl(213610),
		duration: 7000,
	},
	HEART_OF_LIGHT: {
		id: 1839,
		name: 'Heart of Light',
		icon: iconUrl(213609),
		duration: 15000,
	},
	HEART_OF_CORUNDUM: {
		id: 2683,
		name: 'Heart of Corundum',
		icon: iconUrl(213615),
		duration: 15000,
	},
	CATHARSIS_OF_CORUNDUM: {
		id: 2685,
		name: 'Catharsis of Corundum',
		icon: iconUrl(213617),
		duration: 4000,
	},
	CAMOUFLAGE: {
		id: 1832,
		name: 'Camouflage',
		icon: iconUrl(213602),
		duration: 20000,
	},
	NEBULA: {
		id: 1834,
		name: 'Nebula',
		icon: iconUrl(213604),
		duration: 15000,
	},
	GREAT_NEBULA: {
		id: 3838,
		name: 'Great Nebula',
		icon: iconUrl(213619),
		duration: 15000,
	},
	SUPERBOLIDE: {
		id: 1836,
		name: 'Superbolide',
		icon: iconUrl(213606),
		duration: 8000,
	},
	BLOODFEST: SHARED.UNKNOWN,
})
